import { ref, computed } from 'vue'

type AmazonTheme = 'light' | 'dark'

const amazonTheme = ref<AmazonTheme>('light')

// Check for saved theme preference in localStorage
if (typeof window !== 'undefined') {
  const savedTheme = localStorage.getItem('amazon-theme')
  if (savedTheme === 'dark' || savedTheme === 'light') {
    amazonTheme.value = savedTheme
  }
}

export function useAmazonTheme() {
  const toggleTheme = () => {
    amazonTheme.value = amazonTheme.value === 'light' ? 'dark' : 'light'
    // Save to localStorage
    if (typeof window !== 'undefined') {
      localStorage.setItem('amazon-theme', amazonTheme.value)
    }
  }

  const themeClass = computed(() => {
    return amazonTheme.value === 'dark' ? 'amazon-dark' : 'amazon-light'
  })

  const isDark = computed(() => amazonTheme.value === 'dark')

  return {
    amazonTheme: computed(() => amazonTheme.value),
    toggleTheme,
    themeClass,
    isDark
  }
}

